/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

function callToNative (methodName, data) {
  window.postToParent({
    ...data,
    type: methodName
  });
}
export default {
  appLoaded () {
    callToNative('appLoaded');
  },
  appReady (data) {
    callToNative('appok', data);
  },
  exitApp () {
    callToNative('exitApp');
  },
  scanQRCode () {
    callToNative('scanQRCode');
  },
  playAudio ({ type, loop }) {
    callToNative('playAudio', { type, loop });
  },
  stopAudio (type) {
    callToNative('stopAudio', { type });
  },
  reloadApp ({ appurl }) {
    callToNative('appLoading', { appurl });
  },
  shareData ({ img, url, content, title }) {
    callToNative('shareData', {
      img,
      url,
      content,
      title
    });
  },
  copyToClipboard (data) {
    callToNative('copyToClipboard', { data });
  },
  openInBrowser (url) {
    callToNative('openurl', { url });
  },
  joinMeeting ({
    callid,
    room,
    displayName,
    callType,
    bandwidth,
    token,
    micMuted,
    videoEnabled,
    speakerMuted,
    loudSpeaker,
    pip
  }) {
    callToNative('joinMeeting', {
      callid,
      room,
      displayName,
      callType,
      bandwidth,
      token,
      micMuted,
      videoEnabled,
      speakerMuted,
      loudSpeaker,
      pip
    });
  },
  startMeetingStat () {
    callToNative('startMeetingStat');
  },
  stopMeetingStat () {
    callToNative('stopMeetingStat');
  },
  exitMeeting () {
    callToNative('exitMeeting');
  },
  lockMeeting () {
    callToNative('lockMeeting');
  },
  unlockMeeting () {
    callToNative('unlockMeeting');
  },
  pip (data) {
    callToNative('pip', data);
  },
  muteMic () {
    callToNative('muteMic');
  },
  unmuteMic () {
    callToNative('unmuteMic');
  },
  enableVideo () {
    callToNative('enableVideo');
  },
  disableVideo () {
    callToNative('disableVideo');
  },
  enableLoudSpeaker () {
    callToNative('enableLoudSpeaker');
  },
  disableLoudSpeaker () {
    callToNative('disableLoudSpeaker');
  },
  muteSpeaker () {
    callToNative('muteSpeaker');
  },
  unmuteSpeaker () {
    callToNative('unmuteSpeaker');
  },
  sendChat ({ msg, img, url, user }) {
    callToNative('sendChat', { msg, img, url, user });
  },
  terminateMeeting (participants) {
    callToNative('terminateMeeting', { participants });
  },
  inviteUser (toid) {
    callToNative('inviteUser', { toid });
  },
  emitToServer (eventName, data) {
    if (!(typeof data === 'string' || data instanceof String)) {
      try {
        data = JSON.stringify(data);
      } catch (error) { }
    }
    callToNative('emitToServer', {
      eventName,
      eventData: data
    });
  },
  toggleCamera () {
    callToNative('toggleCamera');
  },
  volumeDown () {
    callToNative('volumeDown');
  },
  volumeUp () {
    callToNative('volumeUp');
  },
  userLoginStatus (status) {
    callToNative('userLoginStatus', status);
  },

  startPairingService (info) {
    callToNative('startPairingService', info);
  },
  disconnectControl (device) {
    callToNative('disconnectControl', device);
  },
  getControls () {
    callToNative('getControls');
  },
  sendToControls (message, deviceList) {
  },
  stopPairingService () {
    callToNative('stopPairingService');
  },
  incomingCallTimeout () {
    callToNative('incomingCallTimeout');
  },
  outgoingCallTimeout () {
    callToNative('outgoingCallTimeout');
  },
  tapOnVideo () {
    callToNative('tapOnVideo');
  },
  callAccepted () {
    callToNative('callAccepted');
  },
  callRejected () {
    callToNative('callRejected');
  },
  setUserList (users) {
    callToNative('setUserList', { users });
  },
  enableAutoRotate () {
    callToNative('enableAutoRotate');
  },
  oauthLogin (oauth) {
    callToNative('oauthsignin', { oauth });
  }
};
